// src/pages/PrivacyPolicy.js
import React, { useEffect } from 'react';
import "aos/dist/aos.css";
import AOS from "aos";
import { Container, Card, Row, Col } from 'react-bootstrap';
import { Helmet } from "react-helmet";
const PrivacyPolicy = () => {
   
    useEffect(() => {
        AOS.init({ duration: 1000, once: true });
      }, []);
 
      return (
    <>
      <div className="mainnav min-vh-100">
   
  <Helmet>
      {/* Primary Meta Tags */}
      <title>
        Privacy Policy |Karigar India Namkeen Labour Contractor
      </title>

      <meta
        name="description"
        content="Read the Privacy Policy of Namkeen Labour Contractor. We are committed to protecting your personal information and respecting your privacy when you use our website and services."
      />

      <meta
        name="keywords"
        content="Privacy Policy Namkeen Labour Contractor, Karigar Namkeen Privacy Policy, Data Protection, User Privacy, Website Privacy Policy India"
      />

      <meta name="author" content="Namkeen Labour Contractor" />
      <meta name="robots" content="index, follow" />

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta
        property="og:title"
        content="Privacy Policy | Namkeen Labour Contractor"
      />
      <meta
        property="og:description"
        content="Learn how Namkeen Labour Contractor collects, uses, and protects your personal information."
      />
      <meta property="og:url" content="https://www.karigarindia.in/privacy-policy" />
      <meta property="og:site_name" content="Namkeen Labour Contractor" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary" />
      <meta
        name="twitter:title"
        content="Privacy Policy | Namkeen Labour Contractor"
      />
      <meta
        name="twitter:description"
        content="We respect your privacy and are committed to safeguarding your personal data."
      />

      {/* Contact Info */}
      <meta name="contact" content="info@karigarindia.in" />
      <meta name="phone" content="+91-7008000756" />
      <meta name="address" content="Bhilwara, Rajasthan, India" />
    </Helmet>
        
        <Container className="py-3">
          <Row className="justify-content-center">
            <Col xs={12} md={10}>
              <Card className="shadow-lg ">
                <Card.Body>
                  <Card.Title as="h2" className="middletext mb-1" data-aos="zoom-in">Privacy Policy</Card.Title>
                  <Card.Text>
                    <ul className='p-3'>
                    
                    <li className='mb-2'>
                      <b>Namkeen Labour Contractor</b> is committed to protecting your personal information and respecting your privacy at all times.
                    </li>
               
                    <li className='mb-2'>
                      We collect basic details such as your name, email address, and phone number only when you voluntarily submit them through our website forms.
                    </li >
                    <li className='mb-2'>
                      We do not sell, rent, or share your personal information with any third party without your consent, except when legally required.
                    </li>
                    <li className='mb-2'>We reserve the right to update or modify this Privacy Policy at any time. Changes will be reflected on this page.</li>
                    <li className='mb-2'>
                      If you have any questions regarding this Privacy Policy, please contact us through our website.
                    </li>
                    </ul>
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default PrivacyPolicy;
